import { createSelector } from 'reselect'

const getPrivateLibraryCurrent = state => state.libraries.current

const deleteLessonsSelector = createSelector(
	[getPrivateLibraryCurrent],
	current => ({
		libraryUID: current.libraryUID,
		multipleSchools: current.settings.multipleSchools,
	})
)

export default deleteLessonsSelector
